$.fn.Details = function(_e)
{
	var _details = this;
	_details.e = _e;
	_details.details_list = undefined;
	_details.types_config = undefined;
	_details.interface = {
		element_type_select: _details.find("select[name=element_type]"),
		date1_field: _details.find("input[name=date1]"),
		date2_field: _details.find("input[name=date2]"),
	};

	/* Public */
	_details.getHeaderTitle = function()
	{
		var headerText = _details.interface.element_type_select.find("option:selected").text();
		if (!headerText || headerText == " " || headerText == " " || headerText == ""){
			headerText = "–";
		}
		return headerText;
	};

	_details.getHeaderDates = function()
	{
		var datesString = "";
		if (_details.interface.date1_field.val() != ""){ datesString += _details.interface.date1_field.val(); }
		if (_details.interface.date1_field.val() != "" && _details.interface.date2_field.val() != ""){ datesString += " - "; }
		if (_details.interface.date2_field.val() != ""){ datesString += _details.interface.date2_field.val(); }
		if (!datesString) datesString = "–";
		return datesString;
	};

	/* Private */
	_details.changed = function(event)
	{
		// set property to element
		var key = undefined,
			value = undefined;
		if ($(event.target).data("DateTimePicker") != undefined){
			key = $(event.target).find("input").attr("name");
			var date = $(event.target).data("DateTimePicker").date();
			value = (date != null) ? $(event.target).data("DateTimePicker").date().format("YYYY-MM-DD 00:00:00") : '';
		} else {
			key = $(event.target).attr("name");
			value = $(event.target).val();
		}
		_details.e.set(key, value);

		// element type recalculate
		if (key == 'element_type'){
			_details.details_list.updatedBaseFee();
		}
	};

	/* Get value */
	_details.get_value = function(key)
	{
		// input fields
		var input = _details.find("input[name='" + key + "']");
		if (key === "date1" || key === "date2"){
			var date = input.closest('.element-date-picker').data("DateTimePicker").date();
			return (date != null) ? date.format("YYYY-MM-DD 00:00:00") : undefined;
		} else if (input.length){
			if (input.attr("type") == "checkbox" || input.attr("type") == "radio"){
				return _details.find("input[name='" + key + "']:checked").val();
			} else {
				return _details.find("input[name='" + key + "']").val();
			}
		} else {
			var select = _details.find("select[name='" + key + "']");
			return select.val();
		}
	};
	
	_details.updateTypesSelect = function(maybe_save)
	{
		if (_details.types_config == undefined || _details.types_config != _details.e.getConventionName())
		{
			// insert select choices
			var previousValue = _details.interface.element_type_select.val();
			_details.types_config = _details.e.getConventionName();
			_details.interface.element_type_select.find("option").remove();
			_details.interface.element_type_select.append(_details.find(".template-" + _details.types_config + "-elementtypes option").clone());
			
			// maybe save if value has to change
			if (maybe_save){
				if (previousValue && previousValue != 0 && previousValue != "NONE" && _details.interface.element_type_select.find("option[value=" + previousValue + "]").length){
					_details.interface.element_type_select.val(previousValue);
				} else {
					_details.interface.element_type_select.val("NONE").change();
				}
			}
		}
	};

	return function()
	{
		// static element fields
		_details.find(".static-input-group").on("change", _details.changed);
		_details.find('.element-date-picker').each(function(){
			$(this).on('dp.change', _details.changed);
		});
		
		// details list
		_details.details_list = _details.find(".slr-details-list").DetailsList(_details);
		
		// recalculate rights immediately after all items in element are loaded
		_details.details_list.model.each(function(item){
			if (item.model.item.item_type === "DROITS"){
				item.update();
			}
		});
		
		// details type select
		_details.updateTypesSelect(false);

		// return object
		return _details;
	}();
};
